<template>
  <div>
    <form
      id="invite"
      @submit.prevent="checkForm"
      action="#"
      method="post"
      novalidate="true"
    >
      <table id="inviteForm" class="inviteForm">
        <caption class="caption">
          Add Access Whitelist Form
        </caption>
        <tr class="header">
          <th>
            <label class="required">{{
              $t("admin.adminWhitelistAddForm.type")
            }}</label>
          </th>
          <th>
            <label class="required">{{
              $t("admin.adminWhitelistAddForm.value")
            }}</label>
          </th>
        </tr>
        <tr class="input-wrapper">
          <td width="30%">
            <select class="ip-input" v-model="type">
              <option
                v-for="(option, oIdx) in options"
                v-bind:value="option.value"
                v-bind:key="oIdx"
              >
                {{ option.text }}
              </option>
            </select>
          </td>
          <td>
            <input
              v-bind:class="{ error: formErrors }"
              class="ip-input"
              v-model="newValue"
              v-bind:placeholder="
                type == 0
                  ? $t('admin.adminWhitelistAddForm.placeholder.select.ip')
                  : $t('admin.adminWhitelistAddForm.placeholder.select.email')
              "
              v-on:input="
                errorMsg = '';
                formErrors = false;
              "
            />
            <p class="error errorMsg" v-if="errorMsg">
              {{ errorMsg }}
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <label for="description">{{
              $t("admin.adminWhitelistAddForm.description")
            }}</label>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <textarea
              class="description"
              v-model="description"
              v-bind:placeholder="
                $t('admin.adminWhitelistAddForm.placeholder.description')
              "
              rows="4"
              maxlength="100"
            ></textarea>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div id="counter">{{ description.length }}/100</div>
          </td>
        </tr>

        <input
          v-bind:disabled="loading"
          type="submit"
          class="submit"
          v-bind:value="$t('admin.adminWhitelistAddForm.button.add')"
        />
      </table>
    </form>
  </div>
</template>

<script>
import { validEmail } from "@/utils/validEmail";
import { validIp } from "@/utils/validIp";
import { adminService } from "../../services/admin.service";

export default {
  name: "AdminWhitelistAddForm",
  props: {
    planId: {
      type: Number,
      required: true,
    },
    fetchData: {
      type: Function,
      required: true,
    },
    checkExistingAccess: {
      type: Function,
      required: true,
    },
  },
  data: function () {
    return {
      formErrors: false,
      options: [
        { text: this.$t("admin.adminWhitelistAddForm.select.ip"), value: 0 },
        { text: this.$t("admin.adminWhitelistAddForm.select.email"), value: 1 },
      ],
      newValue: null,
      type: 0,
      description: "",
      errorMsg: "",
      loading: false,
    };
  },
  methods: {
    addField: function () {
      this.allowList.push({
        value: null,
        type: 0,
        description: "",
        error: false,
      });
    },
    removeField: function (idx) {
      this.allowList.splice(idx, 1);
    },
    checkForm: function (event) {
      if (this.loading) return;
      this.loading = true;
      this.formErrors = false;
      this.errorMsg = "";

      if (this.newValue) {
        if (this.checkExistingAccess(this.newValue, -1)) {
          this.formErrors = true;
          this.errorMsg = this.$t(
            "admin.adminWhitelistAddForm.errorMsg.exists"
          );
          this.loading = false;
        }
        if (this.type === 0) {
          const isValueValid = validIp(this.newValue);
          if (!isValueValid) {
            this.formErrors = true;
            this.errorMsg = this.$t("admin.adminWhitelistAddForm.errorMsg.ip");
            this.loading = false;
          }
        } else {
          const isValueValid = validEmail(this.newValue);
          if (!isValueValid) {
            this.formErrors = true;
            this.errorMsg = this.$t(
              "admin.adminWhitelistAddForm.errorMsg.email"
            );
            this.loading = false;
          }
        }
      } else {
        this.formErrors = true;
        this.errorMsg = this.$t("admin.adminWhitelistAddForm.errorMsg.noInput");
        this.loading = false;
      }

      if (!this.formErrors) {
        this.addAccess();
      }

      event.preventDefault();
    },
    addAccess: function () {
      const body = {
        ip: this.type === 0 ? this.newValue : null,
        emailAddress: this.type === 1 ? this.newValue : null,
        description: this.description,
        enabled: true,
      };

      adminService.whitelistCreate(this.planId, body).then((resp) => {
        if (resp.id) {
          this.fetchData();
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
#invite {
  .input-wrapper {
    align-items: center;
    margin-bottom: 23px;
  }

  table {
    width: 100%;
    .caption {
      display: none;
    }
  }

  td {
    background: $surface-alpha;
    color: $text-dark;
    padding: 0;
    vertical-align: top;
  }

  tr.header {
    background: $surface-alpha;
    color: $text-dark;
    th {
      text-align: left;
      border: none;
      padding: 7px 0 7px 5px;
      label {
        width: 100%;
      }
    }
  }

  .ip-input {
    flex: 2 1 auto;
    margin: 0 12px 20px 0;
    font-size: small;
    width: 97%;
    height: 3rem;
  }

  .action {
    flex: 1 0 24px;
    margin: 12px 0 0 10px;
    width: 24px;
    height: 24px;
  }
  .add {
    background: url("../../assets/icons/add.png") no-repeat center center;
  }
  .remove {
    background: url("../../assets/icons/remove.png") no-repeat center center;
  }
  .blank {
    background: none no-repeat center center;
  }

  input.submit {
    margin: 0 0 40px;
    width: auto;
    height: 3rem;
  }

  textarea {
    resize: none;
  }
}

.success-message {
  margin: 0 40px;
  ul {
    li {
      list-style: inside;
      display: list-item;
      padding: 5px 0;
    }
  }
}
.errorMsg {
  margin-top: -20px;
  margin-bottom: 0px;
  font-size: small;
}

.invite-wrap {
  padding-bottom: 40px;
}

#counter {
  text-align: right;
  font-size: 1rem;
  margin-top: -1rem;
  color: $tertiary;
}
</style>
